import request from '@/utils/request'

const url = 'admin/site.space_serial'
/**
 * 场地关联视频记录接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加SpaceVideo
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑SpaceVideo
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情SpaceVideo
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 删除SpaceVideo
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
   * 更改SpaceVideo数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  }

}

export default api
